"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const client_1 = require("@apollo/client");
// //
// // assets
// //
const accountCopy_1 = require("../../../../copy/accountCopy");
const queryDefinitions_1 = require("../../../../queryDefinitions");
//
// components
//
const GenericInput_1 = __importDefault(require("../../../general/inputs/GenericInput"));
const FormValidation_1 = require("../../../general/utility/FormValidation");
//
// styles
//
const StyledInputContainer_1 = require("../StyledInputContainer");
const StyledInvalidFeedback_1 = require("../../StyledInvalidFeedback");
const AccountContext_1 = require("../../../../contexts/AccountContext");
const LocalAccount_1 = __importDefault(require("../../../../LocalAccount"));
const react_bootstrap_1 = require("react-bootstrap");
const MalomoButton_1 = require("../../MalomoButton");
const Overview = (props) => {
    const { setAccount } = (0, AccountContext_1.useAccount)();
    const [accountName, setAccountName] = (0, react_1.useState)('');
    // eslint-disable-next-line no-unused-vars
    const [subdomain, setSubdomain] = (0, react_1.useState)('');
    const [accountNameError, setAccountNameError] = (0, react_1.useState)('');
    const [subdomainError, setSubdomainError] = (0, react_1.useState)('');
    const [buttonStatus, setButtonStatus] = (0, react_1.useState)('');
    function handleBlur(event) {
        const error = (0, FormValidation_1.validateInput)(event.target.id, event.target.value);
        if (error) {
            if (event.target.id === 'accountName') {
                setAccountNameError(error);
            }
            if (event.target.id === 'subdomain') {
                setSubdomainError(error);
            }
        }
        else {
            if (event.target.id === 'accountName') {
                setAccountNameError('');
            }
            if (event.target.id === 'subdomain') {
                setSubdomainError('');
            }
        }
    }
    function handleInputChange(event) {
        if (event.target.id === 'accountName') {
            setAccountName(event.target.value);
        }
        if (event.target.id === 'subdomain') {
            setSubdomain(event.target.value);
        }
    }
    const [changeAccountName, { data: changeAccountData, loading: changeAccountLoading, error: changeAccountError }] = (0, client_1.useMutation)(queryDefinitions_1.UPDATE_ACCOUNT_NAME);
    function handleUpdateAccount() {
        setButtonStatus('Loading...');
        changeAccountName({
            variables: {
                input: {
                    id: LocalAccount_1.default.getId(),
                    name: accountName
                }
            }
        });
    }
    (0, react_1.useEffect)(() => {
        // on initial page load, prefill data with what is in local storage
        setAccountName(localStorage.getItem('account')
            ? // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
                JSON.parse(localStorage.getItem('account')).name
            : '');
        setSubdomain(localStorage.getItem('account')
            ? // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
                JSON.parse(localStorage.getItem('account')).primaryHostedDomain.token
            : '');
        if (changeAccountData) {
            // if update successful, overwrite with latest data
            setAccountName(changeAccountData.updateAccount.account.name);
            setSubdomain(changeAccountData.updateAccount.account.primaryHostedDomain.token);
            setAccount(changeAccountData.updateAccount.account);
            // LocalAccount should no longer be necessary when we start using the
            // account context, but for now there's some duplication
            LocalAccount_1.default.set(changeAccountData.updateAccount.account);
            setButtonStatus('Success!');
            setTimeout(() => {
                setButtonStatus('');
            }, 5000);
        }
        if (changeAccountError) {
            setButtonStatus('');
        }
    }, [changeAccountData, changeAccountError, props.newAccount]);
    function displayApiError(error) {
        if (error.message === 'Failed to fetch') {
            return 'The server could not be reached, please try again later';
        }
        if (error.message.includes('required')) {
            return 'All input is required, please try again';
        }
        return error.message;
    }
    return (react_1.default.createElement(react_bootstrap_1.Fade, { appear: true, in: true },
        react_1.default.createElement(StyledInputContainer_1.StyledInputContainer, null,
            react_1.default.createElement(GenericInput_1.default, { error: accountNameError, id: 'accountName', label: accountCopy_1.accountOverviewCopy.label1, onBlur: handleBlur, onInputChange: handleInputChange, value: accountName }),
            changeAccountError ? (react_1.default.createElement(StyledInvalidFeedback_1.StyledInvalidFeedback, { className: 'api-error invalid-feedback' }, displayApiError(changeAccountError))) : null,
            react_1.default.createElement(GenericInput_1.default, { disabled: true, error: subdomainError, id: 'subdomain', label: accountCopy_1.accountOverviewCopy.label2, onBlur: handleBlur, onInputChange: handleInputChange, spacing: '10px', value: subdomain }),
            react_1.default.createElement(MalomoButton_1.MalomoButton, { className: changeAccountData ? 'account-success' : '', disabled: changeAccountLoading ? changeAccountLoading : false, id: 'account-button', marginTopLarge: true, onClick: handleUpdateAccount, style: { minWidth: '130px', width: '20%' } }, buttonStatus ? buttonStatus : accountCopy_1.accountOverviewCopy.button1))));
};
Overview.propTypes = {
    newAccount: prop_types_1.default.string
};
exports.default = Overview;
